import {
  ListStoreDefault,
  ListRequestHandler,
  ListSuccessHandler,
  ListFilterHandler,
  locationChangePersist,
  storeDefault,
} from 'js/helpers/reducers.js';

import {
  FETCH_NOTIFICATION_LIST,
  FETCHED_NOTIFICATION_LIST,
  SET_NOTIFICATION_LIST_FILTER,
  FETCH_ALERT_SETTINGS,
  FETCHED_ALERT_SETTINGS,
  UPDATE_ALERT_SETTING,
  UPDATE_ALERT_RULE,
  REMOVE_ALERT,
  HIDE_ALERT,
  MARK_ALL_SEEN,
  MARKED_ALL_SEEN,
 } from 'actions/notifications.js';

const defaultState = {
  notificationList: ListStoreDefault({
    pageNum: 1,
    pageSize: 100,
    sort_order: 'desc',
    sort_by: 'created_at',
  }),
  alertSettings: storeDefault({
    insight: {},
    action: {},
    report: {},
  }),
};

const handleUpdateAlertSetting = (state, action) => {
  const { alertType, format, enabled } = action;
  const alertState = state.alertSettings.data;
  const updatedAlertState = {
    ...alertState,
    [alertType]: {
      ...alertState[alertType],
      [format]: enabled,
    },
  };
  return {
    ...state,
    alertSettings: {
      ...state.alertSettings,
      data: updatedAlertState,
    },
  };
};

const handleAllAlertsSeen = (state) => {
  const currentTime = Date.now();
  const alerts = state.notificationList.data;
  const alertsMarkedSeen = alerts.map(alert => ({ ...alert, seen_at: currentTime }));
  return {
    ...state,
    notificationList: {
      ...state.notificationList,
      data: alertsMarkedSeen,
    },
  };
};

const handleUpdateAlertRule = (state, action) => {
  const { rule_id, alertType, rule_enabled } = action;
  const alertState = state.alertSettings.data;
  const alertTypeRules = alertState[alertType].rules;

  const updatedAlertTypeRules = alertTypeRules.map((alert) => {
    if (alert.public_id === rule_id) {
      return {
        ...alert,
        rule_enabled,
      };
    }
    return alert;
  });
  const updatedAlertTypeState = {
    ...alertState[alertType],
    rules: updatedAlertTypeRules,
  };

  const updatedAlertState = {
    ...alertState,
    [alertType]: updatedAlertTypeState,
  };

  return {
    ...state,
    alertSettings: {
      ...state.alertSettings,
      data: updatedAlertState,
    },
  };
};

const handleAlertSettingsFetch = (state, action) => {
  if (action.status === 'success' && (action.data && action.data.length)) {
    const data = action.data;
    const insight = data.filter(alertSetting => alertSetting.alert_type === 'insight');
    const report = data.filter(alertSetting => alertSetting.alert_type === 'report');
    const actions = data.filter(alertSetting => alertSetting.alert_type === 'action');
    return {
      ...state,
      alertSettings: {
        ...state.alertSettings,
        fetched: true,
        fetching: false,
        status: 'success',
        data: {
          insight: insight.length > 0 ? insight[0] : {},
          report: report.length > 0 ? report[0] : {},
          action: actions.length > 0 ? actions[0] : {},
        },
      },
    };
  }
  return {
    ...state,
    alertSettings: {
      ...state.alertSettings,
      fetched: true,
      fetching: false,
      status: action.status,
      data: {
        insight: {},
        report: {},
        action: {},
      },
    },
  };
};

const removeAlertFromList = (state, action) => {
  const alertId = action.alert_id;
  const notificationListState = state.notificationList;
  const notificationListData = notificationListState.data;

  return {
    ...state,
    notificationList: {
      ...notificationListState,
      data: notificationListData.filter(alert => alert.public_id !== alertId),
    },
  };
};

const updateSeenAt = (state, action) => {
  const alertId = action.alert_id;
  const { notificationList } = state;
  const { data } = notificationList;

  const newData = [...data];
  const currentAlertIndex = newData.findIndex(notification => notification.public_id === alertId);

  newData[currentAlertIndex] = { ...newData[currentAlertIndex], seen_at: Date.now() };

  return {
    ...state,
    notificationList: {
      ...notificationList,
      data: newData,
    },
  };
};

const NotificationsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return locationChangePersist(state, action, defaultState, {
        persistEverything: true,
        pathToMatch: `/blueprint`,
      });
    case FETCH_ALERT_SETTINGS:
      return ListRequestHandler(state, action, 'alertSettings', state.alertSettings.data);
    case FETCHED_ALERT_SETTINGS:
      return handleAlertSettingsFetch(state, action);
    case FETCH_NOTIFICATION_LIST:
      return ListRequestHandler(state, action, 'notificationList', state.notificationList.data);
    case FETCHED_NOTIFICATION_LIST:
      return ListSuccessHandler(state, action, 'notificationList');
    case SET_NOTIFICATION_LIST_FILTER:
      return ListFilterHandler(state, action, 'notificationList');
    case UPDATE_ALERT_SETTING:
      return handleUpdateAlertSetting(state, action);
    case UPDATE_ALERT_RULE:
      return handleUpdateAlertRule(state, action);
    case REMOVE_ALERT:
      return removeAlertFromList(state, action);
    case HIDE_ALERT:
      return updateSeenAt(state, action);
    case MARK_ALL_SEEN:
      return ListRequestHandler(state, action, 'notificationList', state.notificationList.data);
    case MARKED_ALL_SEEN:
      return handleAllAlertsSeen(state);
    default:
      return Object.assign({}, state);
  }
};

export default NotificationsReducer;
